// extracted by mini-css-extract-plugin
export default {"infoContainer":"style_infoContainer__7L+Cc","infoContent":"style_infoContent__i-kiU"};